<!-- pds-svg-foru-plus-vertical-color-yellow-tm is the single pantry class used for every B4U+
     logo/icon; pantry draws the artwork from it (see the scss for sizing and tint). -->
<span class="foru-plus-logo pds-svg-foru-plus-vertical-color-yellow-tm"
      [style.--foru-plus-tint]="tint"
      [style.--foru-plus-logo-height]="height"
      [attr.role]="decorative ? null : 'img'"
      [attr.aria-label]="decorative ? null : ariaLabel"
      [attr.aria-hidden]="decorative ? 'true' : null"></span>
